module.exports = __webpack_public_path__ + "fonts/Prompt-Medium.bd536c63.ttf";